module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Leistungen_BG_.036e5119.jpg";